import { QuestionCircleOutlined } from "@ant-design/icons";
import React from "react";
import "./help.css";

export const HelpLine = ({ children, ...args }) => {
  return (
    <p {...args}>
      <QuestionCircleOutlined style={{ marginRight: 8 }} />
      {children}
    </p>
  );
};
